import { defaultSearchFormState } from 'config/SearchForm/defaults';
import { createStore } from 'jotai';

import { filterAtom } from './Filter';
import { metaAtom } from './Meta';
import { baseSearchFormAtom, occupancyAtom } from './Search';

export const formStore = createStore();
formStore.set(baseSearchFormAtom, defaultSearchFormState);

export const filterStore = createStore();
filterStore.set(filterAtom, defaultSearchFormState.current.filter);
filterStore.set(occupancyAtom, defaultSearchFormState.current.occupancy);
filterStore.set(metaAtom, defaultSearchFormState.meta);

export const searchStore = createStore();
searchStore.set(baseSearchFormAtom, defaultSearchFormState);
